import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { SupportIcon } from './Icons';
import ContactIcons from './ContactIcons';

const FloatingSocialButtons = () => {
  const { appSettings } = useSelector((state) => state.common);
  const contacts = appSettings?.contacts || [];
  const openWidth = contacts.length > 0 ? 64 * (contacts.length) + 68 : 0;
  const openHeight = contacts.length > 0 ? 49 * (contacts.length) + 53 : 0;
  const [isOpen, setIsOpen] = useState(false);

  const toggleButtons = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Wrapper openWidth={openWidth} openHeight={openHeight} isOpen={isOpen}>
      <MainButton as="div" onClick={toggleButtons}>
        <SupportIcon/>
      </MainButton>

      <ContactIcons isOpen={isOpen} sort='asc'/>
    </Wrapper>
  );
};

export default FloatingSocialButtons;

const Wrapper = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-top: -4px;
  padding: 4px;
  gap: 4px;
  width: ${(props) => (props.isOpen ? `${props.openWidth}px` : '68px')};
  z-index: 100;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  transition: width 0.3s ease, height 0.3s ease;
  @media (max-width: 798px) {
    position: absolute;
    bottom: auto;
    right: auto;
    flex-direction: column;
    min-width: 53px;
    width: 53px;
    height: ${(props) => (props.isOpen ? `${props.openHeight}px` : '53px')};
  }
`
const Button = styled.a`
  position: relative;
  min-width: 60px;
  min-height: 60px;
  border-radius: 18px;
  background-color: ${(props) => props.bgColor || '#EA394B'};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  color: #ffffff !important;
  text-decoration: none;
  transition: transform 0.3s ease, opacity 0.3s ease;
  &:hover {
    transform: scale(1.05);
    color: #ffffff;
    text-decoration: none;
  }
  @media (max-width: 798px) {
    min-width: 45px;
    min-height: 45px;
  }
`
const MainButton = styled(Button)`
  z-index: 2;
  @media (max-width: 798px) {
    background-color: #f1f1f1;
    svg {
      color: #2c2e32;
    }
  }
`
